import "./style.less";
import CheckoutErrors from "./factory";
import BookingComplete from "./booking-complete/module";
import BookingInfoModule from "./booking-info/module";
import bookingOptionsController from "./booking-options";
import paymentCompleteController from "./payment-complete";
import PaymentRedirectModule from "./payment-redirect/module";
import PaymentReceiptUidController from "./payment-receipt-uid";
import CheckoutComponents from "./components/module";

const modul = angular
    .module("Checkout", [
        CheckoutComponents,
        BookingComplete,
        BookingInfoModule,
        PaymentRedirectModule,
    ])

    .factory("CheckoutErrors", CheckoutErrors)
    .controller("bookingOptionsController", bookingOptionsController)
    .controller("PaymentReceiptUidController", PaymentReceiptUidController)
    .controller("paymentCompleteController", paymentCompleteController);

export default modul.name;
